import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import PartnerAccountUpdateModalUI from './PartnerAccountUpdateModalUI.js'

class PartnerAccountUpdateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            response: null,
            //
            guarantorName: '',
            coBorrowerName: '',
            // form events
            submitted: false,
            // form fields
            partnerType: '',
            partnerTypeError: null,
            partnerAccountId: '',
            partnerAccountIdError: null,
        }
    }

    render() {
        let partnerTypeList = [
            { key: 'co-borrower', value: 'Co-Borrower' },
            { key: 'guarantor', value: 'Guarantor' },
        ]
        return (
            <PartnerAccountUpdateModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                response={this.state.response}
                //
                guarantorName={this.state.guarantorName}
                coBorrowerName={this.state.coBorrowerName}
                //accountList
                accountList={this.props.accountList}
                // modes
                updateMode={this.props.updateMode}
                submitted={this.state.submitted}
                // event handlers
                onSubmit={this.onSubmit}
                onCancelClick={this.props.onCancelClick}
                onGuarantorUpdateClick={this.props.onGuarantorUpdateClick}
                // form fields
                partnerTypeList={partnerTypeList}
                partnerType={this.state.partnerType}
                onPartnerTypeChange={(event) => { this.setState({ partnerType: event.target.value }) }}
                partnerTypeError={this.state.partnerTypeError}
                setPartnerTypeError={(error) => { this.setState({ partnerTypeError: error }) }}

                partnerAccountId={this.state.partnerAccountId}
                onPartnerAccountIdChange={(event) => { this.setState({ partnerAccountId: event.target.value }) }}
                partnerAccountIdError={this.state.partnerAccountIdError}
                setPartnerAccountIdError={(error) => { this.setState({ partnerAccountIdError: error }) }}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        if (this.state.submitted) return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.put(this.props.context,
            `/api/su/accounts/${this.props.account.accountId}/guarantors`,
            this.onSubmitCallback,
            {
                accountId: this.props.account.accountId,
                partnerAccountId: this.state.partnerAccountId,
                partnerType: this.state.partnerType
            }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            response: response,
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({ successMsg: null })
                this.props.onCancelClick()
            }, 2000)
        }
    }


    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
        if (errorList && errorList.length > 0)
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
}

export default withRouter(PartnerAccountUpdateModalSF)
